/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { AppRoutes } from '@/constants/routes';
import { Trigger, TriggersViewer } from '@antflow-triggers-component';
import React from 'react';
import { useNavigate } from 'react-router';

export const TriggerList: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToForm = () => {
    navigate(AppRoutes.trigger.new.path);
  };

  const handleNavigateToDetail = (trigger: Trigger) => {
    navigate(AppRoutes.trigger.detail.url(trigger.id));
  };

  const handleNavigateToEdit = (trigger: Trigger) => {
    navigate(AppRoutes.trigger.edit.url(trigger.id));
  };

  return (
    <div className="p-4 w-full text-left">
      <h2 className="ml-3">Triggers List</h2>
      <TriggersViewer
        onNavigateToForm={handleNavigateToForm}
        onNavigateToDetail={handleNavigateToDetail}
        onNavigateToEdit={handleNavigateToEdit}
      />
    </div>
  );
};
